import { FC } from "react";
import { Datagrid, EmailField, List, TextField } from "react-admin";

import CustomPagination from "../../components/CustomPagination";
import EmptyDataText from "../../components/EmptyDataText";
import ListImage from "../../components/ListImage";
import TimestampField from "../../components/TimestampField";
import useSharedStyles from "../../hooks/useSharedStyles";
import BrandsFilters from "./components/BrandsFilter";
import BrandStatus from "./components/BrandStatus";

const BrandsList: FC<any> = (props) => {
  const { styles } = useSharedStyles();

  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      filters={<BrandsFilters />}
      exporter={false}
    >
      <Datagrid rowClick="edit" empty={<EmptyDataText message="No brands yet!" />}>
        <TextField source="displayName.en" label="Name" sortable={false} cellClassName={styles.truncate2} />
        <EmailField source="email" label="Email" sortable={false} />
        <ListImage source="logo.src" label="Logo" sortable={false} />
        <BrandStatus label="Status" />
        <TimestampField source="createdAt" label="Created At" />
      </Datagrid>
    </List>
  );
};

export default BrandsList;
